<template>
    <div>
        <!-- <vue-headful v-bind:title="$t('contact.metadata.title')" v-bind:description="$t('contact.metadata.description')" ogLocale="sv_SE" lang="sv-SE"/>         -->
        
            <section id="hero2" class="hero2 img-lines-container" :style="{background: 'url(/images/computer-2.jpeg)'} ">
            <div class="section-content">
                <div class="container">
                    <header class="col-md-6 msg-box">
                        <div class="hero2-text">
                            <h1>{{$t("contact.hero.title")}}</h1>
                            <p class="lead">{{$t("contact.hero.preamble")}}</p>
                            <p>{{$t("contact.hero.email-title")}} {{$t("contact.hero.email")}}<br>{{$t("contact.hero.phone-title")}} {{$t("contact.hero.phone")}}</p>
                            <p>{{$t("contact.hero.visit-address-title")}}<br>{{$t("contact.hero.visit-address-row1")}}<br>{{$t("contact.hero.visit-address-row2")}}</p>
                            <p>{{$t("contact.hero.billing-address-title")}}<br>{{$t("contact.hero.billing-address-row1")}}<br>{{$t("contact.hero.billing-address-row2")}}</p>
                        </div>
                    </header>
                </div>
                <div class="img-lines"></div>
            </div>
        </section>

        <section id="form">
            <div class="container">
                <div class="section-content">
                    <div class="text-area">                    
                        <div v-html="$t('contact.content.upper-html')" ></div>
                        <form name="ask-question" method="post" data-netlify="true" data-netlify-honeypot="bot-field">
                            <input type="hidden" name="form-name" value="ask-question" />
                            <h2>{{$t("contact.form.title")}}</h2>
                            <div class="form-group">
                                <label for="name">{{$t("contact.form.name")}}*</label>
                                <input type="text" class="form-control form-control-danger" name="name" v-bind:placeholder="$t('contact.form.name')" v-model="name">
                                <div class="form-control-feedback"></div>
                            </div>
                            <div class="form-group">
                                <label for="email">{{$t("contact.form.mail")}}*</label>
                                <input type="text" class="form-control form-control-danger" name="email" v-bind:placeholder="$t('contact.form.mail')" v-model="email">
                                <div class="form-control-feedback"></div>
                            </div>
                            <div class="form-group">
                                <label for="heading">{{$t("contact.form.subject")}}*</label>
                                <input type="text" class="form-control form-control-danger" name="heading" v-bind:placeholder="$t('contact.form.subject')" v-model="subject">
                                <div class="form-control-feedback"></div>
                            </div>
                            <div class="form-group">
                                <label for="body">{{$t("contact.form.body")}}*</label>
                                <textarea class="form-control form-control-danger" name="body" rows="15" v-model="message"></textarea>
                                <div class="form-control-feedback"></div>
                            </div>
                            <button type="submit" class="btn btn-dark" v-bind:disabled="name === '' || !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) || subkect === '' || message === ''">{{$t("contact.form.submit")}}</button>
                        </form>
                        <div v-html="$t('contact.content.lower-html')" ></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
   export default {
        name: 'app',
        components: {
        },
        data() {
            return {
                name: '',
                email: '',
                subject: '',
                message:  ''
            }
        }
    }
</script>

<style scoped>
    .btn-dark {
        background-color: #373a3c;
        color: white;
        border-radius: 4px;
    }
    .hero2 {
        background-position: center !important;
        background-size: cover !important;
        background-repeat: no-repeat !important;
        padding-top: 3.9rem;
    }

    .hero2 .msg-box {
        z-index: 10;
        padding: 0;
    }

    .hero2-text {
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 1.875rem;
    }
</style>